(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name webAgro1App.controller:HistoricoRecomendacoesWrapperCtrl
   * @description
   * # HistoricoRecomendacoesWrapperCtrl
   * Controller of the webAgro1App
   */
  angular
    .module('webAgro1App')
    .controller('HistoricoRecomendacoesWrapperCtrl', HistoricoRecomendacoesWrapper);

  HistoricoRecomendacoesWrapper.$inject = [
    '$scope',
    '$timeout',
    '$rootScope',
    '$route',
    '$routeParams'
  ];

  // eslint-disable-next-line max-lines-per-function, max-params
  function HistoricoRecomendacoesWrapper($scope, $timeout, $rootScope, $route, $routeParams) {
    const vm = this;

    //////////////////////////////////////////
    // Controller data
    vm.activeTab = null;
    vm.open = false;
    vm.disabled = {
      recomendacao: true,
      recomendacaoCorrecaoSolo: true,
      recomendacaoAdubacaoCobertura: true
    };

    //////////////////////////////////////////
    // Bindable methods
    vm.activate = Activate;

    //////////////////////////////////////////
    // Function declarations

    /**
     * Tells nested controller to load its recommendations
     * @param       {string} type controller type listener name
     */
    function Activate(type) {
      $timeout(function() {
        $scope.$broadcast(`${type}Activate`);
      }, 0);
    }

    function UpdateRouteParams(tab = null) {
      $route.updateParams({
        activeRecommendationsTab: tab,
        activeRecommendation: null,
        recommendationFilters: null,
        notification: null
      });
    }

    //////////////////////////////////////////
    // Controller logic

    // instantiate nested controllers and auto-triggers first activation
    $scope.$on('historyRecommendations', function(event, gleba, notificacao) {
      if (notificacao) {
        if (notificacao.tipo === 'recomendacao_operacao_correcao_solo') {
          vm.activeTab = 'correcaoSolo';
        } else if (notificacao.tipo === 'recomendacao_operacao_adubacao') {
          vm.activeTab = 'adubacao';
        } else {
          vm.activeTab = notificacao.tipo;
        }
      }
      vm.open = true;
    });

    // verifies for permissions
    $rootScope.initialize.then(function() {
      const permissions = Object.keys(vm.disabled);
      permissions.forEach(function(key) {
        vm.disabled[key] = !$rootScope.permissions[key].canRead;
        if (!vm.disabled[key] && !vm.activeTab) {
          vm.activeTab = key;
        }
      });

      if ($routeParams.activeTab) {
        vm.activeTab = $routeParams.activeTab;
      }
    });

    // forces reset and reload
    $scope.$on('recommendations_close', function() {
      vm.open = false;
      UpdateRouteParams();
    });

    // new propriedade behavior
    $scope.$watch('sidebar', function(value) {
      if (value === 'recommendations') {
        if ($routeParams.activeRecommendationsTab) {
          vm.activeTab = $routeParams.activeRecommendationsTab;
        }
        vm.open = true;
      }
    });

    $scope.$watch('recWrap.activeTab', function(newVal, oldVal) {
      if (newVal !== oldVal) {
        UpdateRouteParams(newVal);
      }
    });

    $scope.$on('$destroy', UpdateRouteParams);

    $scope.$on('$routeUpdate', function() {
      if ($routeParams.activeTab || $routeParams.notification) {
        vm.activeTab = $routeParams.activeTab || $routeParams.notification;
      }
    });
  }
}());
